import { LocaleDict } from "@/i18n";
import { t } from "i18next";
import { ComputeFieldComponent } from "../../computeFields";

export const SupportTechniqueCF: ComputeFieldComponent<{
  support?: LocaleDict<string> | null;
  technique?: LocaleDict<string> | null;
  isDoubleSided?: boolean;
  preposition?: string;
  doubleFace?: string;
}> = ({ input, lineBreak, language }) => {
  const hasTechnique = !!input.technique?.[language];
  const hasSupport = !!input.support?.[language];
  const isDoubleFaced = input.isDoubleSided === true;

  if (!hasTechnique && !hasSupport && !isDoubleFaced) {
    return <> </>;
  }

  return (
    <>
      {hasTechnique && <>{input.technique?.[language]}</>}
      {hasTechnique && hasSupport && (
        <>
          {" "}
          {input.preposition ||
            t("computeField.techniqueSupportPreposition")}{" "}
        </>
      )}
      {hasSupport && <>{input.support?.[language]}</>}
      {isDoubleFaced && (
        <> ({input.doubleFace || t("computeField.doubleFace")})</>
      )}
      {(hasTechnique || hasSupport || isDoubleFaced) && lineBreak && <br />}
    </>
  );
};
